import React from 'react'

const Vendors = () => {
  return (
    <div>Vendors</div>
  )
}

export default Vendors